import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  createFolder(request: Boundaries["createFolder"]["request"]): void;
}

function useCreateFolder(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(selector.isCreateFolderRequestPending),
    isRequestSuccess: useSelector(selector.isCreateFolderRequestSuccess),
    isRequestFailure: useSelector(selector.isCreateFolderRequestFailure),
    createFolder: core.createFolder,
  };
}

export { useCreateFolder };
